module.exports = __webpack_public_path__ + "img/kreuzspitze.294b8f5e.jpg";